import React, { Component } from 'react'
import '../styles/CalendarActivity.css'
import DropdownWidget from '../widgets/DropdownWidget'
import OrgFooter from '../widgets/OrgFooter'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIGenericRequest from '../api/APIGenericRequest'
import APICalendarRequest from '../api/APICalendarRequest'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import AlertMessage from '../widgets/AlertMessage'
import EncodeAttendance from './EncodeAttendance'
import DatePicker from '../widgets/DatePicker'

class CalendarActivity extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			siteId: localStorage.getItem("siteId"),
			itemRP: {},
			keyTracerRP: 0,
			resourcePersons: {},
			itemFacilitator: {},
			keyTracerFacilitator: 0,
			facilitators: {},
			addResourcePersons: {},
			deleteResourcePersons: {},
			addFacilitators: {},
			deleteFacilitators: {},
			region: "-- SELECT --",
			province: "-- SELECT --",
			city: "-- SELECT --",
			barangay: "-- SELECT --",
			participant: "-- SELECT --",
			trainingModule: "-- SELECT --",
			activityType: "-- SELECT --",
			participantType: "-- SELECT --",
			trainingDuration: 0,
			showAttendance: props.withAttendance,
			title: "ACTIVITY DETAILS",
			activityId: props.activityId
		};
		this.eventHandlerResourcePerson = this.eventHandlerResourcePerson.bind(this)
		this.eventHandlerFacilitator = this.eventHandlerFacilitator.bind(this)
		this.getAllTypesOfActivity = this.getAllTypesOfActivity.bind(this)
		this.getAllRegions = this.getAllRegions.bind(this)
		this.getAllProvincesByRegionId = this.getAllProvincesByRegionId.bind(this)
		this.getAllCitiesByProvinceId = this.getAllCitiesByProvinceId.bind(this)
		this.getAllBarangaysByCityId = this.getAllBarangaysByCityId.bind(this)
		this.getAllParticipantTypes = this.getAllParticipantTypes.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.getActivityById = this.getActivityById.bind(this)
		this.setResourcePerson = this.setResourcePerson.bind(this)
		this.setFacilitators = this.setFacilitators.bind(this)
		this.getAllTrainingModules = this.getAllTrainingModules.bind(this)
		this.addTrainingModule = this.addTrainingModule.bind(this)
		this.confirmDeleteRecord = this.confirmDeleteRecord.bind(this)
		this.getRegionById = this.getRegionById.bind(this)
		this.getProvinceById = this.getProvinceById.bind(this)
		this.requiredInputAlertMessage = this.requiredInputAlertMessage.bind(this)
	}

	onSubmit() {
		console.log('activityId', this.state.activityId)
		if(this.state.activityTypeId == null && this.state.acvitiyId == null) {
			this.requiredInputAlertMessage("Type of Activity")
			return
		}
		console.log('this.state.activityTitle', this.state.activityTitle)
		if((this.state.activityTitle == null ||
			this.state.activityTitle === "-- SELECT --" ||
			this.state.activityTitle === "") &&
			this.state.newModule == null
		) {
			this.requiredInputAlertMessage("Activity Title")
			return
		}
		if(this.state.participantTypeId == null) {
			this.requiredInputAlertMessage("Type of Participant")
			return
		}
		if(this.state.startDate == null) {
			this.requiredInputAlertMessage("Start Date")
			return
		}
		if(this.state.endDate == null) {
			this.requiredInputAlertMessage("End Date")
			return
		}
		// if(this.state.startTime == null) {
		// 	this.requiredInputAlertMessage("Start Time")
		// 	return
		// }
		// if(this.state.endTime == null) {
		// 	this.requiredInputAlertMessage("End Time")
		// 	return
		// }
		if(this.state.venue == null || this.state.venue == "") {
			this.requiredInputAlertMessage("Venue")
			return
		}
		if(this.state.regionId == null && this.state.activityId == null) {
			this.requiredInputAlertMessage("Region")
			return
		}
		if(this.state.provinceId == null && this.state.activityId == null) {
			this.requiredInputAlertMessage("Province")
			return
		}
		if(this.state.cityId == null && this.state.activityId == null) {
			this.requiredInputAlertMessage("City")
			return
		}
		if(this.state.barangayId == null && this.state.activityId == null) {
			this.requiredInputAlertMessage("Barangay")
			return
		}
		this.setState({showActivityIndicator: true})
		const resourcePersons = []
		Object.values(this.state.resourcePersons).forEach((v => {
			resourcePersons.push(v)
		}))
		const addResourcePersons = []
		Object.values(this.state.addResourcePersons).forEach((v => {
			addResourcePersons.push(v)
		}))
		const deleteResourcePersons = []
		Object.values(this.state.deleteResourcePersons).forEach((v => {
			deleteResourcePersons.push(v)
		}))
		const facilitators = []
		Object.values(this.state.facilitators).forEach((v) => {
			facilitators.push(v)
		})
		const addFacilitators = []
		Object.values(this.state.addFacilitators).forEach((v) => {
			addFacilitators.push(v)
		})
		const deleteFacilitators = []
		Object.values(this.state.deleteFacilitators).forEach((v) => {
			deleteFacilitators.push(v)
		})
		const data = {
			"activity": {
				"activity_type_id": this.state.activityTypeId,
				"participant_type_id": this.state.participantTypeId,
				"training_module_id": this.state.trainingModuleId,
				"activity_title": (this.state.newModule != null)? this.state.newModule: this.state.activityTitle,
				"start_date": this.state.startDate, //"2020-06-30",
				"end_date": this.state.endDate,
				"start_time": this.state.startTime,
				"end_time": this.state.endTime,
				"no_of_days": this.state.trainingDuration,
				"site_id": this.state.siteId,
				"region_id": this.state.regionId,
				"province_id": this.state.provinceId,
				"city_id": this.state.cityId,
				"barangay_id": this.state.barangayId,
				"venue": this.state.venue
			},
			"resourcePerson": resourcePersons,
			"facilitator": facilitators,
			add: {
				resourcePerson: addResourcePersons,
				facilitator: addFacilitators
			},
			delete: {
				resourcePerson: deleteResourcePersons,
				facilitator: deleteFacilitators
			}
		}
		console.log(data)
		if(!this.state.shouldDisplayValues) {
			const apiReq = APICalendarRequest.addActivity(this.state.accessToken, data)
			apiReq.then((response) => {
				console.log('addActivity', response)
				if(response.status === "FAILED") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				if(response.status === "ERROR") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.error,
						showActivityIndicator: false
					})
					return
				}
				this.addTrainingModule()
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + " " + response.description,
					submitAdd: false,
					showActivityIndicator: false
				})
			})
		}
		else {
			const apiReq = APICalendarRequest.editActivity(this.state.accessToken, data, parseInt(this.state.activityId))
			apiReq.then((response) => {
				console.log('editActivity', response)
				if(response.status === "FAILED") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				if(response.status === "ERROR") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.error,
						showActivityIndicator: false
					})
					return
				}
				this.addTrainingModule()
				this.setState({
					showInfoMessage: true,
					aMessage: response.status + "! " + " " + response.description,
					submitAdd: false,
					showActivityIndicator: false
				})
			})
		}
	}

	requiredInputAlertMessage(str) {
		this.setState({
			showWarningMessage: true,
			aMessage: `${str} is required. All fields with the asterisk (*) symbol must have values.`
		})
	}

	addTrainingModule() {
		if(this.state.newModule != null) {
			var data = {trainingModule: [{
				name: this.state.newModule,
				participant_type_id: this.state.participantTypeId
			}]}
		}
		const apiReq = APICalendarRequest.addTrainingModule(this.state.accessToken, data)
		apiReq.then((response) => {
		})
	}

	componentWillMount() {
		this.setResourcePerson()
		this.setFacilitators()
		this.getAllTypesOfActivity()
		this.getAllRegions()
		this.getAllParticipantTypes()
		if(this.state.activityId != null) {
			this.getActivityById(this.state.activityId)
		}
	}

	getActivityById(id) {
		this.setState({showActivityIndicator: true})
		const types = APICalendarRequest.getActivityById(this.state.accessToken, id);
		types.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			if(response.status === "ERROR") {
				return;
			}
			if(response.results.activity.activity_type_id == 1) {
				this.getAllTrainingModules()
			}
			this.getRegionById(response.results.activity.region_id)
			this.getProvinceById(response.results.activity.province_id)
			this.setResourcePerson(response.results.resourcePerson)
			this.setFacilitators(response.results.facilitator)
			this.setState({
				activityId: response.results.activity.activity_id,
				activityTypeId: response.results.activity.activity_type_id,
				participantTypeId: response.results.activity.participant_type_id,
				barangayId: response.results.activity.barangay_id,
				cityId: response.results.activity.city_id,
				provinceId: response.results.activity.province_id,
				regionId:  response.results.activity.region_id,
				activityType: response.results.activity.activity_type,
				participantType: response.results.activity.participant_type,
				activityTitle: response.results.activity.activity_title.toUpperCase(),
				startDate: response.results.activity.start_date,
				endDate: response.results.activity.end_date,
				startTime: response.results.activity.start_time,
				endTime: response.results.activity.end_time,
				venue: response.results.activity.venue,
				city: response.results.activity.city,
				barangay: response.results.activity.barangay,
				trainingDuration: response.results.activity.no_of_days,
				shouldDisplayValues: true,
				showActivityIndicator: false
			});
		});
	}

	getRegionById(id) {
		const region = APIGenericRequest.getRegionById(this.state.accessToken, id)
		region.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			this.setState({region: response.results.name})
		})
	}

	getProvinceById(id) {
		const region = APIGenericRequest.getProvinceById(this.state.accessToken, id)
		region.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			this.setState({province: response.results.name})
		})
	}

	getAllTypesOfActivity() {
		const types = APICalendarRequest.getAllActivityTypes(this.state.accessToken);
		types.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.activity_type_id, name: v.name});
			}
			this.setState({typesOfActivity: c});
		});
	}

	getAllParticipantTypes() {
		const types = APICalendarRequest.getAllParticipantTypes(this.state.accessToken);
		types.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.participant_type_id, name: v.name});
			}
			this.setState({participants: c});
		});
	}

	getAllRegions() {
		const region = APIGenericRequest.getAllRegions(this.state.accessToken)
		region.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.region_id, name: v.name})
			}
			this.setState({
				regions: c,
			})
		})
	}

	getAllProvincesByRegionId(id, reset) {
		const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, id)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name})
			}
			if(reset) {
				this.setState({
					provinces: c,
					province: "-- SELECT --",
					city: "-- SELECT --",
					barangay: "-- SELECT --"
				})
			}
			else {
				this.setState({provinces: c})
			}
		})
	}

	getAllCitiesByProvinceId(id, reset) {
		const city = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.city_id, name: v.name})
			}
			if(reset) {
				this.setState({
					cities: c,
					city: "-- SELECT --",
					barangay: "-- SELECT --"
				})
			}
			else {
				this.setState({cities: c})
			}
		})
	}

	getAllBarangaysByCityId(id, reset) {
		const city = APIGenericRequest.getAllBarangaysByCityId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.barangay_id, name: v.name})
			}
			if(reset) {
				this.setState({
					barangays: c,
					barangay: "-- SELECT --"
				})
			}
			else {
				this.setState({barangays: c})
			}
		})
	}

	getAllTrainingModules() {
		const modules = APICalendarRequest.getAllTrainingModules(this.state.accessToken);
		modules.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
				c.push({id: 0, name: "-- ADD NEW MODULE --"});
			for(const v of response.results.rows) {
				c.push({id: v.training_module_id, name: v.name});
			}
			this.setState({trainingModules: c});
		});
	}

	confirmDeleteRecord() {
		this.setState({
			showConfirmMessage: true,
			aMessage: "Are you sure you want to delete this record?"
		})
	}

	setResourcePerson(resourcePerson) {
		const persons = []
		const itemRP = {}
		if(resourcePerson != null) {
			for(const v of resourcePerson) {
				const k = "rp-" + this.state.keyTracerRP
				itemRP[k] = <ResourcePerson data={v} handler={this.eventHandlerResourcePerson}
					showAlert={this.confirmDeleteRecord}
					disabled={this.state.isViewDetails} key={k} id={k} />
				this.state.keyTracerRP++
			}
			const k = "rp-" + this.state.keyTracerRP
			itemRP[k] = <ResourcePerson handler={this.eventHandlerResourcePerson}
					showAlert={this.confirmDeleteRecord}
				disabled={this.state.isViewDetails} key={k} id={k} />
			this.state.keyTracerRP++
			Object.keys(itemRP).forEach((k => {
				persons.push(itemRP[k])
			}))
		}
		else {
			const k = "rp-" + this.state.keyTracerRP
			itemRP[k] = <ResourcePerson handler={this.eventHandlerResourcePerson}
					showAlert={this.confirmDeleteRecord}
				key={k} id={k} />
			this.state.keyTracerRP++
			persons.push(itemRP[k])
		}
		this.setState({persons: persons, itemRP: itemRP})
	}

	setFacilitators(facilitators) {
		const persons = []
		const itemFacilitator = {}
		if(facilitators != null) {
			for(const v of facilitators) {
				const k = "f-" + this.state.keyTracerFacilitator
				itemFacilitator[k] = <Facilitator data={v} handler={this.eventHandlerFacilitator}
					showAlert={this.confirmDeleteRecord}
					disabled={this.state.isViewDetails} key={k} id={k} />
				this.state.keyTracerFacilitator++
			}
			const k = "f-" + this.state.keyTracerFacilitator
			itemFacilitator[k] = <Facilitator handler={this.eventHandlerFacilitator}
					showAlert={this.confirmDeleteRecord}
				disabled={this.state.isViewDetails} key={k} id={k} />
			this.state.keyTracerFacilitator++
			Object.keys(itemFacilitator).forEach((k => {
				persons.push(itemFacilitator[k])
			}))
		}
		else {
			const k = "f-" + this.state.keyTracerFacilitator
			itemFacilitator[k] = <Facilitator handler={this.eventHandlerFacilitator}
					showAlert={this.confirmDeleteRecord}
				key={k} id={k} />
			this.state.keyTracerFacilitator++
			persons.push(itemFacilitator[k])
		}
		this.setState({
			facilitatorList: persons,
			itemFacilitator: itemFacilitator
		})
	}

	eventHandlerFacilitator(e, compId, key, value) {
		switch(e) {
			case "facilitator":
				if(this.state.facilitators == null) {
					this.state.facilitators = {}
				}
				this.state.facilitators[compId] = value
				break
			case "add":
				this.state.addFacilitators[compId] = value
				const added = []
				const k = "f-" + this.state.keyTracerRP
				this.state.itemFacilitator[k] = <Facilitator handler={this.eventHandlerFacilitator}
					showAlert={this.confirmDeleteRecord} key={k} id={k} />
				this.state.keyTracerRP++
				Object.keys(this.state.itemFacilitator).forEach((k => {
					added.push(this.state.itemFacilitator[k])
				}))
				this.setState({facilitatorList: added})
				break
			case "delete":
				this.state.deleteFacilitators[compId] = value
				delete this.state.facilitators[compId]
				delete this.state.itemFacilitator[compId]
				const deleted = []
				Object.keys(this.state.itemFacilitator).forEach((k => {
					deleted.push(this.state.itemFacilitator[k])
				}))
				this.setState({facilitatorList: deleted})
		}
	}

	eventHandlerResourcePerson(e, compId, key, value) {
		switch(e) {
			case "resource-person":
				if(this.state.resourcePersons == null) {
					this.state.resourcePersons = {}
				}
				this.state.resourcePersons[compId] = value
				break
			case "add":
				this.state.addResourcePersons[compId] = value
				const added = []
				const k = "rp-" + this.state.keyTracerRP
				this.state.itemRP[k] = <ResourcePerson handler={this.eventHandlerResourcePerson}
					showAlert={this.confirmDeleteRecord} key={k} id={k} />
				this.state.keyTracerRP++
				Object.keys(this.state.itemRP).forEach((k => {
					added.push(this.state.itemRP[k])
				}))
				this.setState({persons: added})
				break
			case "delete":
				this.state.deleteResourcePersons[compId] = value
				delete this.state.resourcePersons[compId]
				delete this.state.itemRP[compId]
				const deleted = []
				Object.keys(this.state.itemRP).forEach((k => {
					deleted.push(this.state.itemRP[k])
				}))
				this.setState({persons: deleted})
		}
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this));
		this.setScrollable();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this));
	}

	onResize() {
		this.setScrollable();
	}

	setScrollable() {
		const sa = document.getElementById('ca-scroll-area');
		const ca = document.getElementById('ca-client-area');
		if(ca == null || sa == null) {
			return;
		}
		if(sa.clientHeight < ca.clientHeight+104) {
			this.setState({scrollable: true});
		}
		else {
			this.setState({scrollable: false});
		}
	}

	render() {
		const view = <div id="calendar-activity">
			<div id="ca-scroll-area"><div id="ca-client-area">
			<div className="title-bar">{this.state.title}</div>
				<div id="ca-cell1">
					<div id="ca-cell1-r1">
						<div id="ca-cell1-r1-i1">
							<div style={{'margin-bottom': '5px'}}>* Type of Activity</div>
							<DropdownWidget list={this.state.typesOfActivity} placeholder={this.state.activityType}
								cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
									let actTitle = ""
									if(id == 1 || id == 2) {
										this.getAllTrainingModules()
										actTitle = "-- SELECT --"
									}
									this.setState({
										activityTypeId: id,
										activityTitleId: -1,
										trainingModuleId: null,
										activityTitle: actTitle
									})
								}} />
						</div>
						<div id="ca-cell1-r1-i2">
							<div>* Activity Title</div>
							{(this.state.activityTypeId == 1 || this.state.activityTypeId == 2) && <div style={{'margin-top': '5px'}}><DropdownWidget list={this.state.trainingModules}
								cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
									if(id == 0) {
										this.setState({trainingModuleId: null, tm: 0})
									}
									else {
										this.setState({trainingModuleId: id, activityTitle: val})
									}
								}} placeholder={this.state.activityTitle} /></div>}
							{(this.state.activityTypeId != 1 && this.state.activityTypeId != 2)&& <input type="text" onChange={(e) => {
								this.setState({activityTitle: e.target.value.toUpperCase()})
							}} style={{"width": "100%"}} placeholder={this.state.activityTitle} />}
							{(this.state.tm == 0 && (this.state.activityTypeId == 1 || this.state.activityTypeId == 2)) && <input type="text"
								onChange={(e) => {
									this.setState({newModule: e.target.value.toUpperCase()})
								}} placeholder="ENTER TITLE OF THE NEW MODULE"/>}
						</div>
						<div id="ca-cell1-r1-i3" >
							<div style={{'margin-bottom': '5px'}}>* Type of Participant</div>
							<DropdownWidget list={this.state.participants}onItemSelected={(id, val) => {
								this.setState({participantTypeId: id})
							}} cStyle={{"width": "100%"}} placeholder={this.state.participantType}  />
						</div>
					</div>
					<div id="ca-cell1-r2">
						<div id="ca-cell1-r2-i1">
							<div>* Start Date</div>
							<DatePicker onChange={(value) => {
								const sd = new Date(value)
								const ed = new Date(this.state.endDate)
								const td = Date.parse(ed) - Date.parse(sd)
								const duration = (((td / 1000) / 60) / 60) / 24
								this.setState({startDate: value, trainingDuration: (isNaN(duration))? 0: duration+1})
							}} value={this.state.startDate} />
						</div>
						<div id="ca-cell1-r2-i2">
							<div>* End Date</div>
							<DatePicker onChange={(value) => {
								const sd = new Date(this.state.startDate)
								const ed = new Date(value)
								const td = Date.parse(ed) - Date.parse(sd)
								const duration = (((td / 1000) / 60) / 60) / 24
								this.setState({endDate: value, trainingDuration: (isNaN(duration))? 0: duration+1})
							}} value={this.state.endDate} />
						</div>
						<div id="ca-cell1-r2-i3">
							<div>Training Duration</div>
							<input type="text" value={this.state.trainingDuration} disabled />
							<span>Day/s</span>
						</div>
						<div id="ca-cell1-r2-i4">
							<div>Time</div>
							<div>
								<span>From:</span>
								<input type="time" onChange={(e) => {
									this.setState({startTime: e.target.value + ":00"})
								}} value={this.state.startTime} />
								<span>To:</span>
								<input type="time" onChange={(e) => {
									this.setState({endTime: e.target.value + ":00"})
								}} value={this.state.endTime} />
							</div>
						</div>
					</div>
					<div id="ca-cell1-r3">
						<div id="ca-cell1-r3-i1">
							<div>* Venue</div>
							<input type="text" onChange={(e) => {
								this.setState({venue: e.target.value})
							}} value={this.state.venue} />
						</div>
						<div id="ca-cell1-r3-i2">
							<div style={{'margin-bottom': '5px'}}>* Region</div>
							<DropdownWidget list={this.state.regions} placeholder={this.state.region}
								onItemSelected={(id, val) => {
									this.setState({
										regionId: id,
										provinceId: null,
										cityId: null,
										barangayId: null,
										province: null,
										city: null,
										barangay: null
									})
									this.getAllProvincesByRegionId(id, true)
								}}  cStyle={{"width": "100%"}} />
						</div>
						<div id="ca-cell1-r3-i2">
							<div style={{'margin-bottom': '5px'}}>* Province</div>
							<DropdownWidget list={this.state.provinces} placeholder={this.state.province}
								onItemSelected={(id, val) => {
									this.setState({
										provinceId: id,
										cityId: null,
										barangayId: null,
										city: null,
										barangay: null
									})
									this.getAllCitiesByProvinceId(id, true)
								}}  cStyle={{"width": "100%"}} />
						</div>
						<div id="ca-cell1-r3-i2">
							<div style={{'margin-bottom': '5px'}}>* City/Municipality</div>
							<DropdownWidget list={this.state.cities} placeholder={this.state.city}
								onItemSelected={(id, val) => {
									this.setState({
										cityId: id,
										barangayId: null,
										barangay: null
									})
									this.getAllBarangaysByCityId(id, true)
								}}  cStyle={{"width": "100%"}} />
						</div>
						<div id="ca-cell1-r3-i3">
							<div style={{'margin-bottom': '5px'}}>* Barangay</div>
							<DropdownWidget list={this.state.barangays} placeholder={this.state.barangay}
								onItemSelected={(id, val) => {
									this.setState({barangayId: id})
								}} cStyle={{"width": "100%"}} />
						</div>
					</div>
				</div>
				<div id="ca-flex">
				<div id="ca-cell2">
					<div style={{'margin-left': '15px', 'margin-bottom': '15px'}}>RESOURCE PERSON/S:</div>
					<div id="ca-resource-persons">{this.state.persons}</div>
				</div>
				<div id="ca-cell3">
					<div style={{'margin-left': '15px', 'margin-bottom': '15px'}}>FACILITATOR/S:</div>
					<div id="ca-facilitators">{this.state.facilitatorList}</div>
				</div>
				</div>
				{this.state.showAttendance && <EncodeAttendance />}
			</div>{this.state.scrollable === true && <OrgFooter submit={this.onSubmit} showSubmit={(this.state.user.role_id == 3)? true: false} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer"><OrgFooter submit={this.onSubmit} showSubmit={(this.state.user.role_id == 3)? true: false} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false, shouldDisplayValues: true})
					this.props.onSignal("calendar")

			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
			{/* <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} /> */}
		</div>
		return(view)
	}
}

class ResourcePerson extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			personData: {},
			person: "-- SELECT --",
			extName: "EXT",
			sex: "SEX"
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken);
		ext.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name});
			}
			c.push({id: 0, name: "N/A"});
			this.setState({extNames: c});
		})
		const sex = APIGenericRequest.getAllSex(this.state.accessToken);
		sex.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.sex_id, name: v.name});
			}
			this.setState({sc: c});
		})
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.personData["id"] = this.props.data.id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				firstName: this.props.data.first_name,
				middleName: this.props.data.middle_name,
				lastName: this.props.data.last_name,
				extName: this.props.data.extension_name,
				sex: (this.props.data.sex_code == "F")? "FEMALE": "MALE",
				addDeleteButton: addDeleteButton
			})
			return;
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.personData)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		const fn = this.state.personData.first_name? this.state.personData.first_name: ''
		const ln = this.state.personData.last_name? this.state.personData.last_name: ''
		const name = `${fn} ${ln}`
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove resource person ${name.toUpperCase()}?`
		})
	}

	render() {
		const view = <div className="resource-person">
			<div>{this.state.addDeleteButton}</div>
			<input type="text" onChange={(e) => {
				this.state.personData["first_name"] = e.target.value
				this.props.handler("resource-person", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
				this.setState({firstName: e.target.value})
			}} value={this.state.firstName} placeholder='FIRST NAME' />
			<input type="text" onChange={(e) => {
				this.state.personData["middle_name"] = e.target.value
				this.props.handler("resource-person", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
				this.setState({middleName: e.target.value})
			}} value={this.state.middleName} placeholder='MIDDLE NAME' />
			<input type="text" onChange={(e) => {
				this.state.personData["last_name"] = e.target.value
				this.props.handler("resource-person", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
				this.setState({lastName: e.target.value})
			}} value={this.state.lastName} placeholder='LAST NAME' />
			<DropdownWidget list={this.state.extNames} placeholder={this.state.extName}
			onItemSelected={(id, val) => {
				let n = val
				if(id == 0) {
					n = null
				}
				this.state.personData["extension_name"] = n
				this.props.handler("resource-person", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
			}} cStyle={{"width": "60px", "margin-right": "5px"}} />
			<DropdownWidget list={this.state.sc} placeholder={this.state.sex}
			onItemSelected={(id, val) => {
				this.state.personData["sex_code"] = (id == 0)? 'M': 'F'
				this.props.handler("resource-person", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
			}} cStyle={{"width": "90px"}} />
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.props.handler("delete", this.state.itemId, null, this.state.personData)
				}
			}} />}
		</div>
		return(view)
	}
}

class Facilitator extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			personData: {},
			person: "-- SELECT --",
			extName: "EXT",
			sex: "SEX",
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentWillMount() {
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken);
		ext.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name});
			}
			c.push({id: 0, name: "N/A"});
			this.setState({extNames: c});
		})
		const sex = APIGenericRequest.getAllSex(this.state.accessToken);
		sex.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.sex_id, name: v.name});
			}
			this.setState({sc: c});
		})
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.personData["id"] = this.props.data.id
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				firstName: this.props.data.first_name,
				middleName: this.props.data.middle_name,
				lastName: this.props.data.last_name,
				extName: this.props.data.extension_name,
				sex: (this.props.data.sex_code == "F")? "FEMALE": "MALE",
				addDeleteButton: addDeleteButton
			})
			return;
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.personData)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		const fn = this.state.personData.first_name? this.state.personData.first_name: ''
		const ln = this.state.personData.last_name? this.state.personData.last_name: ''
		const name = `${fn} ${ln}`
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove facilatator ${name.toUpperCase()}?`
		})
	}


	render() {
		const view = <div className="facilitator">
			<div>{this.state.addDeleteButton}</div>
			<input type="text" onChange={(e) => {
				this.state.personData["first_name"] = e.target.value
				this.props.handler("facilitator", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
				this.setState({firstName: e.target.value})
			}} value={this.state.firstName} placeholder='FIRST NAME' />
			<input type="text" onChange={(e) => {
				this.state.personData["middle_name"] = e.target.value
				this.props.handler("facilitator", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
				this.setState({middleName: e.target.value})
			}} value={this.state.middleName} placeholder='MIDDLE NAME' />
			<input type="text" onChange={(e) => {
				this.state.personData["last_name"] = e.target.value
				this.props.handler("facilitator", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
				this.setState({lastName: e.target.value})
			}} value={this.state.lastName} placeholder='LAST NAME' />
			<DropdownWidget list={this.state.extNames} placeholder={this.state.extName}
			onItemSelected={(id, val) => {
				let n = val
				if(id == 0) {
					n = null
				}
				this.state.personData["extension_name"] = n
				this.props.handler("facilitator", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
			}} cStyle={{"width": "60px", "margin-right": "5px"}} />
			<DropdownWidget list={this.state.sc} placeholder={this.state.sex}
			onItemSelected={(id, val) => {
				this.state.personData["sex_code"] = (id == 1)? 'M': 'F'
				this.props.handler("facilitator", this.state.itemId, null, this.state.personData)
				if(this.state.addDeleteButton.props.alt == "ADD") {
					this.onAddItemClick()
				}
			}} cStyle={{"width": "90px"}} />
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}

				{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.props.handler("delete", this.state.itemId, null, this.state.personData)
				}
			}} />}

		</div>
		return(view)
	}
}

export default CalendarActivity
